/* Sticky header + announcement-bar collapse-on-scroll
   Each Dawn 15 header-group section is a SIBLING with class
   .shopify-section-group-header-group. We tag announcement
   sections individually via .announcement-bar-section. */
(function () {
  const announcementSections = Array.from(
    document.querySelectorAll('.announcement-bar-section')
  );
  const mainHeader = document.querySelector('.section-header');

  if (announcementSections.length === 0 && !mainHeader) return;

  const threshold = 40;
  let ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const scrolled = window.scrollY > threshold;
      document.body.classList.toggle('eb-scrolled', scrolled);
      if (mainHeader) mainHeader.classList.toggle('eb-header-scrolled', scrolled);
      announcementSections.forEach((el) =>
        el.classList.toggle('eb-bar-collapsed', scrolled)
      );
      ticking = false;
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
